import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({})
export default class HorizontalScrollCarousel extends Vue {
  @Prop({ default: "24px" }) gap;
  @Prop({ default: "key" }) carouselKey;
  @Prop({ default: 100 }) scrollQuantity;

  @Getter getIsUnderMobile;

  scrollCarousel(direction: number) {
    const carouselContent = document.getElementById(`carouselContent-${this.carouselKey}`);
    const scrollLeft = carouselContent.scrollLeft;
    carouselContent.scrollTo({
      top: 0,
      left: scrollLeft + this.scrollQuantity * direction,
      behavior: "smooth",
    });
  }
}
